import React from 'react';
// import PropTypes from 'prop-types';

const withActiveCarouselState = (WrappedComponent) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                activeLocations: [],
            }
        }

        componentDidUpdate(prevProps, prevState, snapshot) {

        }

        onActiveCallback = locationID => {
            if (!this.state.activeLocations.includes(locationID)) {
                this.setState(state => {
                    let activeLocations = [locationID].concat(state.activeLocations);

                    if (activeLocations.length > 4) {
                        activeLocations.length = 4;
                    }
                    return { activeLocations };
                });
            }
        }

        render() {
            return <WrappedComponent
                {...this.props}
                {...this.state}
                // smallScreen={this.smallScreen}
                onActiveCallback={this.onActiveCallback}
            />;
        }
    }
}

export default withActiveCarouselState;
